<script>

import WDevicePolicyViolationView from '@/views/config/group/netdevice/components/DevicePolicyViolationView';
import MapAPI from '@/api/topologymap/common';

export default {
  name: 'WTopologymapDevicePolicyViolationView',
  extends: WDevicePolicyViolationView,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active && this.activeTab === this.$options.name) {
        if (this.tableDataType === 'device') {
          const tableParams = this.$refs.deviceTable.getParameter();
          const params = {
            ...this.params,
            ...tableParams,
            mapId: this.$store.getters.getCurrentMapId,
          };
          MapAPI
            .getNetdeviceDeviceViolationList(params).then((result) => {
              if (result.data.success === true) {
                this.deviceTableData = result.data.data;
                this.total = result.total;
              }
            });
        } else if (this.tableDataType === 'policy') {
          const tableParams = this.$refs.policyTable.getParameter();
          const params = {
            ...this.params,
            ...tableParams,
            mapId: this.$store.getters.getCurrentMapId,
          };
          MapAPI
            .getNetdevicePolicyViolationList(params).then((result) => {
              if (result.data.success === true) {
                this.policyTableData = result.data.data;
                this.total = result.total;
              }
            });
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/config/components/netdevice/TopologymapDevicePolicyViolationView.vue